<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-toc" id="table-of-contents">
<div class="toc-heading"><h1 class="toc-title">Contents</h1></div>
<div class="toc-contents">
<div class="toc-frontmatter-group">
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-acknowledgments has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/acknowledgments"><span class="element-title-text">Acknowledgments</span></a></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-foreword has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/foreword"><span class="element-title-text">Foreword</span></a></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-preface has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/preface"><span class="element-title-text">Preface</span></a></p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-part has-no-leading-number has-children has-no-page-number">
<p class="element-title"><a href="#/part001"><span class="element-title-text">Part I</span></a></p>
</div>
<div class="child-contents">
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/part001helpwantedparttimeworkfulltimehours"><span class="element-title-text">Help Wanted (part-time work, full-time hours)</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/part001chapter001"><span class="element-title-text">Chapter 1</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/part001chapter002"><span class="element-title-text">Chapter 2</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/part001chapter003"><span class="element-title-text">Chapter 3</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/part001chapter004"><span class="element-title-text">Chapter 4</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/part001chapter005" title="Link target outside of Sample"><span class="element-title-text">Chapter 5</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/part001chapter006" title="Link target outside of Sample"><span class="element-title-text">Chapter 6</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/part001chapter007" title="Link target outside of Sample"><span class="element-title-text">Chapter 7</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/part001chapter008" title="Link target outside of Sample"><span class="element-title-text">Chapter 8</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/part001chapter009" title="Link target outside of Sample"><span class="element-title-text">Chapter 9</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/part001chapter010" title="Link target outside of Sample"><span class="element-title-text">Chapter 10</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/part001chapter011" title="Link target outside of Sample"><span class="element-title-text">Chapter 11</span></span></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/part001refs" title="Link target outside of Sample"><span class="element-title-text">Refs</span></span></p>
</div>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-part has-no-leading-number has-children has-no-page-number">
<p class="element-title"><span href="#/part002" title="Link target outside of Sample"><span class="element-title-text">Part II</span></span></p>
</div>
<div class="child-contents">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/part002chapter012" title="Link target outside of Sample"><span class="element-title-text">Chapter 12</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/part002chapter013" title="Link target outside of Sample"><span class="element-title-text">Chapter 13</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/part002chapter014" title="Link target outside of Sample"><span class="element-title-text">Chapter 14</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/part002chapter015" title="Link target outside of Sample"><span class="element-title-text">Chapter 15</span></span></p>
</div>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-part has-no-leading-number has-children has-no-page-number">
<p class="element-title"><span href="#/part003" title="Link target outside of Sample"><span class="element-title-text">Part III</span></span></p>
</div>
<div class="child-contents">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/part003chapter016" title="Link target outside of Sample"><span class="element-title-text">Chapter 16</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/part003chapter017" title="Link target outside of Sample"><span class="element-title-text">Chapter 17</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/part003chapter018" title="Link target outside of Sample"><span class="element-title-text">Chapter 18</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/part003chapter019" title="Link target outside of Sample"><span class="element-title-text">Chapter 19</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/part003chapter020" title="Link target outside of Sample"><span class="element-title-text">Chapter 20</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/part003chapter021" title="Link target outside of Sample"><span class="element-title-text">Chapter 21</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/part003chapter022" title="Link target outside of Sample"><span class="element-title-text">Chapter 22</span></span></p>
</div>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-endnotes has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/notes" title="Link target outside of Sample"><span class="element-title-text">Notes</span></span></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-also-by has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/alsobyrichardlister" title="Link target outside of Sample"><span class="element-title-text">Also by Richard Lister</span></span></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/abouttheauthor" title="Link target outside of Sample"><span class="element-title-text">About the Author</span></span></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4f60c772